module.exports = __webpack_public_path__ + "img/testimonial-8-61x61_1testimonial-8-61x61.4a02569d.png";